<div class="alert-box">
    <!-- <div class="alert-header">
        <span>{{data.title}}</span>
        <a [mat-dialog-close]="false"><img width="20" src='assets/images/close-commentbox-icon.png'></a> 
    </div> -->
    <div class="alert-content">
        <!-- <a [mat-dialog-close]="false"><img width="20" src='assets/images/close-commentbox-icon.png'></a>  -->
        <span style="font-size: 16x;"><strong>EXPORT TO {{title | uppercase }}</strong></span>
        
        <!-- <span>
            {{data.message}}
        </span> -->
        <br>
        <div class="col-md-12 text-center">
            <button class="btn btn-blue" value="all"  (click)="confirm('all')">ALL</button>
            <button class="btn btn-blue" value="true"  (click)="confirm('true')">TRUE</button>
            <button class="btn btn-blue" value="false" (click)="confirm('false')">FALSE</button>
        </div>
    </div>
</div>